/**
 * [ECOMHARD] Card alternativo Webasic.
 * Isolado do hover/slider/swatch nativos. Funciona também após filtros AJAX.
 * Os preços/títulos são escritos pelo Liquid; só buscamos as imagens dos
 * produtos de outras cores quando uma dessas cores é selecionada.
 */
(function () {
  'use strict';

  var cardSelector = '[data-ecomhard-card]';
  var galleryCache = new Map();
  var states = new WeakMap();

  function imageUrl(value) {
    if (!value || typeof value !== 'string') return '';
    try {
      var url = new URL(value, window.location.origin);
      // Mantém versão e outros parâmetros, solicitando dimensão otimizada à CDN Shopify.
      if (/cdn\.shopify\.com|\/cdn\/shop\//.test(url.hostname + url.pathname)) {
        url.searchParams.set('width', '900');
      }
      return url.toString();
    } catch (e) {
      return value;
    }
  }

  function normalizeGallery(images, fallback) {
    var cleaned = (Array.isArray(images) ? images : [])
      .map(function (item) {
        return imageUrl(typeof item === 'string' ? item : (item && (item.src || item.url)));
      })
      .filter(Boolean);
    if (!cleaned.length && fallback) cleaned = [imageUrl(fallback)];
    return cleaned;
  }

  function query(card, selector) { return card.querySelector(selector); }

  function setImage(card, index) {
    var state = states.get(card);
    if (!state || !state.gallery.length) return;
    state.index = ((index % state.gallery.length) + state.gallery.length) % state.gallery.length;
    card.dataset.imageIndex = String(state.index);
    var img = query(card, '[data-ecomhard-image]');
    if (!img) {
      var place = query(card, '[data-ecomhard-image-placeholder]');
      if (place) {
        img = document.createElement('img');
        img.className = 'ecomhard-alt-image';
        img.setAttribute('data-ecomhard-image', '');
        img.setAttribute('loading', 'lazy');
        img.setAttribute('decoding', 'async');
        place.replaceWith(img);
      }
    }
    if (img) {
      var target = state.gallery[state.index];
      if (img.src !== target) img.src = target;
      img.alt = (query(card, '[data-ecomhard-title]') || {}).textContent || '';
    }
    var progress = query(card, '[data-ecomhard-progress]');
    if (progress) {
      Array.prototype.forEach.call(progress.children, function (segment, i) {
        var active = i === state.index;
        segment.classList.toggle('is-active', active);
        segment.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }
  }

  function setGallery(card, images, fallback) {
    var state = states.get(card);
    if (!state) return;
    state.gallery = normalizeGallery(images, fallback);
    state.index = 0;
    var multiple = state.gallery.length > 1;
    var prev = query(card, '[data-ecomhard-prev]');
    var next = query(card, '[data-ecomhard-next]');
    var progress = query(card, '[data-ecomhard-progress]');
    if (prev) prev.hidden = !multiple;
    if (next) next.hidden = !multiple;
    if (progress) {
      var frag = document.createDocumentFragment();
      if (multiple) {
        state.gallery.forEach(function (_, i) {
          var segment = document.createElement('button');
          segment.type = 'button';
          segment.dataset.ecomhardSlide = String(i);
          segment.setAttribute('aria-label', 'Ver imagem ' + (i + 1) + ' de ' + state.gallery.length);
          frag.appendChild(segment);
        });
      }
      progress.replaceChildren(frag);
    }
    setImage(card, 0);
  }

  function syncWishlist(card, button) {
    var wish = query(card, '.ecomhard-alt-media [data-icon-wishlist]');
    if (!wish || !button) return;
    var handle = button.dataset.handle;
    var id = button.dataset.id;
    wish.setAttribute('data-product-handle', handle);
    wish.setAttribute('data-id', id);
    wish.setAttribute('aria-label', 'Adicionar ' + (button.dataset.title || 'produto') + ' aos favoritos');
    // O halo.js utiliza $.data(), que guarda o valor anterior em cache.
    if (window.jQuery) {
      window.jQuery(wish).data('product-handle', handle);
      window.jQuery(wish).data('id', Number(id));
    }
    var saved = [];
    try { saved = JSON.parse(window.localStorage.getItem('items') || '[]'); } catch (e) { /* sem storage */ }
    var selected = Array.isArray(saved) && saved.indexOf(handle) !== -1;
    wish.classList.toggle('whislist-added', selected);
    wish.setAttribute('aria-pressed', String(selected));
  }

  function initCard(card) {
    if (states.has(card)) return;
    var images = [];
    try { images = JSON.parse(card.dataset.gallery || '[]'); } catch (e) { images = []; }
    states.set(card, { gallery: [], index: 0, version: 0, touch: null, suppressClickUntil: 0 });
    var fallback = card.dataset.featured || '';
    var normalized = normalizeGallery(images, fallback);
    if (card.dataset.handle) galleryCache.set(card.dataset.handle, normalized);
    setGallery(card, normalized, fallback);
    syncWishlist(card, query(card, '[data-ecomhard-swatch].is-selected'));
  }

  function loadGallery(handle) {
    if (galleryCache.has(handle)) return Promise.resolve(galleryCache.get(handle));
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var path = root.replace(/\/?$/, '/') + 'products/' + encodeURIComponent(handle) + '.js';
    var request = fetch(path, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Não foi possível carregar as imagens');
        return response.json();
      })
      .then(function (product) {
        var result = normalizeGallery(product.images, product.featured_image);
        if (!result.length) throw new Error('Produto sem imagens');
        galleryCache.set(handle, result);
        return result;
      })
      .catch(function (err) {
        galleryCache.delete(handle); // possibilita nova tentativa
        throw err;
      });
    galleryCache.set(handle, request); // deduplica requisições simultâneas
    return request;
  }

  function changeColor(card, button) {
    initCard(card);
    var state = states.get(card);
    var handle = button.dataset.handle;
    if (!handle) return;
    var version = ++state.version;
    card.dataset.handle = handle;
    card.dataset.imageIndex = '0';

    var title = query(card, '[data-ecomhard-title]');
    var color = query(card, '[data-ecomhard-color-name]');
    var now = query(card, '[data-ecomhard-now]');
    var was = query(card, '[data-ecomhard-was]');
    var sale = query(card, '[data-ecomhard-sale]');
    var swatches = card.querySelectorAll('[data-ecomhard-swatch]');
    var isSale = Boolean(button.dataset.compare);
    var url = button.dataset.url || '/products/' + encodeURIComponent(handle);

    card.classList.toggle('on-sale', isSale);
    if (title) title.textContent = button.dataset.title || '';
    if (color) {
      color.textContent = button.dataset.color || '';
      color.hidden = !button.dataset.color;
    }
    if (now) now.textContent = button.dataset.price || '';
    if (was) { was.textContent = button.dataset.compare || ''; was.hidden = !isSale; }
    if (sale) sale.hidden = !isSale;
    card.querySelectorAll('[data-ecomhard-link]').forEach(function (link) {
      link.setAttribute('href', url);
      if (link.classList.contains('ecomhard-alt-image-link')) {
        link.setAttribute('aria-label', 'Ver ' + (button.dataset.title || 'produto'));
      }
    });
    swatches.forEach(function (swatch) {
      var active = swatch === button;
      swatch.classList.toggle('is-selected', active);
      swatch.setAttribute('aria-pressed', String(active));
    });
    syncWishlist(card, button);

    var fallback = button.dataset.featured || '';
    var media = query(card, '[data-ecomhard-media]');
    if (media) media.style.setProperty('--ecomhard-media-aspect', button.dataset.aspect || '1');
    if (galleryCache.has(handle)) {
      Promise.resolve(galleryCache.get(handle)).then(function (gallery) {
        if (version === state.version) setGallery(card, gallery, fallback);
      }).catch(function () {
        if (version === state.version) setGallery(card, [], fallback);
      });
      // Mostra imediatamente a primeira imagem da nova cor mesmo se a galeria estiver baixando.
      setGallery(card, [], fallback);
    } else {
      setGallery(card, [], fallback);
      loadGallery(handle).then(function (gallery) {
        if (version === state.version) setGallery(card, gallery, fallback);
      }).catch(function () {
        if (version === state.version) setGallery(card, [], fallback);
      });
    }
  }

  function onCardClick(event) {
    var card = event.target.closest(cardSelector);
    if (!card) return;
    initCard(card);
    var state = states.get(card);
    var target = event.target;

    if (target.closest('[data-ecomhard-image]') || target.closest('.ecomhard-alt-image-link')) {
      if (Date.now() < state.suppressClickUntil) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }
    }
    var swatch = target.closest('[data-ecomhard-swatch]');
    if (swatch && card.contains(swatch)) {
      event.preventDefault();
      changeColor(card, swatch);
      return;
    }
    var more = target.closest('[data-ecomhard-more]');
    if (more && card.contains(more)) {
      event.preventDefault();
      var wrapper = query(card, '[data-ecomhard-swatches]');
      if (wrapper) {
        var expanded = wrapper.classList.toggle('is-expanded');
        more.setAttribute('aria-expanded', String(expanded));
        more.setAttribute('aria-label', expanded ? 'Ocultar cores adicionais' : 'Mostrar cores adicionais');
      }
      return;
    }
    var arrow = target.closest('[data-ecomhard-prev], [data-ecomhard-next]');
    if (arrow && card.contains(arrow)) {
      event.preventDefault();
      setImage(card, state.index + (arrow.hasAttribute('data-ecomhard-next') ? 1 : -1));
      return;
    }
    var segment = target.closest('[data-ecomhard-slide]');
    if (segment && card.contains(segment)) {
      event.preventDefault();
      setImage(card, parseInt(segment.dataset.ecomhardSlide, 10));
    }
  }

  function handleTouchStart(event) {
    var card = event.target.closest(cardSelector);
    if (!card || !event.target.closest('[data-ecomhard-media]')) return;
    if (event.target.closest('.ecomhard-alt-media [data-icon-wishlist]')) return;
    initCard(card);
    if (event.touches.length !== 1) return;
    var state = states.get(card);
    state.touch = { x: event.touches[0].clientX, y: event.touches[0].clientY };
  }
  function handleTouchEnd(event) {
    var card = event.target.closest(cardSelector);
    if (!card) return;
    var state = states.get(card);
    if (!state || !state.touch || !event.changedTouches.length) return;
    var dx = event.changedTouches[0].clientX - state.touch.x;
    var dy = event.changedTouches[0].clientY - state.touch.y;
    state.touch = null;
    if (state.gallery.length > 1 && Math.abs(dx) > 35 && Math.abs(dx) > Math.abs(dy) * 1.4) {
      state.suppressClickUntil = Date.now() + 500;
      setImage(card, state.index + (dx < 0 ? 1 : -1));
    }
  }

  function start() {
    document.querySelectorAll(cardSelector).forEach(initCard);
    document.addEventListener('click', onCardClick);
    document.addEventListener('touchstart', handleTouchStart, { passive: true });
    document.addEventListener('touchend', handleTouchEnd, { passive: true });
    document.addEventListener('touchcancel', function (event) {
      var card = event.target.closest(cardSelector);
      if (card && states.has(card)) states.get(card).touch = null;
    }, { passive: true });
    // O tema substitui grades após filtros/paginação sem recarregar o documento.
    if (window.MutationObserver && document.body) {
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType !== 1) return;
            if (node.matches && node.matches(cardSelector)) initCard(node);
            if (node.querySelectorAll) node.querySelectorAll(cardSelector).forEach(initCard);
          });
        });
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
